import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { partialRight } from 'lodash';
import { Message, MessageService } from 'primeng/api';
import { QuestionBank } from 'src/app/misc/data/questionBank';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';


@Component({
  selector: 'app-user-survey-result',
  templateUrl: './user-survey-result.component.html',
  styleUrls: ['./user-survey-result.component.scss'],
  providers: [MessageService]
})
export class UserSurveyResultComponent {
  survey: any;

  loading: boolean = false;
  isArray: any = Array.isArray
  messages: Message[] = [];

  constructor(
    private dataService: DataService,
    private activeRoute: ActivatedRoute,
    private router: Router,

  ) { }

  ngOnInit() {
    this.activeRoute.params.subscribe(params => {
      let surveyId = params['surveyId'];
      let email = params['email'];
      if (surveyId && email) {
        this.getSurveyResults(surveyId, email);
      } else {
        this.router.navigate(['/home'])
      }
    })
  }

  async getSurveyResults(surveyId: string, email: string) {
    try {
      this.loading = true;
      let url = 'survey-attempt/' + surveyId + '/' + email;
      let res = await this.dataService.getData(url);
      this.loading = false;
      if (res.error) {
        console.log(res.error);
        return;
      }
      console.log(res.data);
      this.survey = res.data;
      if (!this.isArray(this.survey)) {
        this.markAttendance(email);
      }
    } catch (e) {
      console.log(e);
    }
  }

  getName(name: any) {
    return Object.values(name).join(' ');
  }

  async markAttendance(email: string) {
    try {
      let url = 'survey-attendance/mark';
      let data = {
        surveyId: this.survey.surveyId,
        email: email,
        markType: 'BY_QR'
      }
      let res = await this.dataService.postData(url, data);
      if (res.error) {
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
    } catch (e) {
    }
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

}
